import { loadCookiefirst } from '@/external_scripts/cookiefirst'
import { loadElbwalker } from '@/external_scripts/elbwalker'
import { loadGtm } from '@/external_scripts/gtm'
import { loadNewRelic } from '@/external_scripts/newrelic.ts'

const CF_CONSENT_EVENT = 'cf_consent'
const CF_CONSENT_INIT = 'cf_init'
const CF_CONSENT_LOADED = 'cf_consent_loaded'

/** Resolves when New Relic is ready to accept noticeError. Await before creating the app to avoid losing early errors. */
export const newRelicReadyPromise = loadNewRelic()

export const injectScripts = async () => {
  window.addEventListener(CF_CONSENT_EVENT, () => {
    loadScripts()
  })
  window.addEventListener(CF_CONSENT_INIT, () => {
    loadScripts()
  })
  window.addEventListener(CF_CONSENT_LOADED, () => {
    loadScripts()
  })
  await loadCookiefirst()
}

async function loadScripts() {
  const { default: CF } = await import('@/services/helpers/CookieFirstHelper')

  loadElbwalker(CF.getConsent())

  if (CF.getFunctionalConsent()) {
    await loadGtm()
  }
}

injectScripts()
